var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoDownloadBlue = function SvgIcoDownloadBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "ico_download")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "16_TeamAbout",
    transform: "translate(-637.000000, -7657.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAQs",
    transform: "translate(120.000000, 7647.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Faqs_block",
    transform: "translate(510.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico_download",
    transform: "translate(7.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.500000, 8.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5,16.5 L18.5,16.5 C18.5,17.6045695 17.6045695,18.5 16.5,18.5 L2.5,18.5 C1.3954305,18.5 0.5,17.6045695 0.5,16.5 L0.5,16.5 L0.5,16.5 Z",
    id: "Rectangle",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-26",
    stroke: "#000000",
    strokeWidth: 2,
    points: "3.88999988 6.40062514 9.5 11.8868753 15.1100001 6.40062514"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy",
    fill: "#000000",
    transform: "translate(1.500000, 15.000000) rotate(90.000000) translate(-1.500000, -15.000000) ",
    points: "0 14 3 14 3 16 4.54386528e-13 16"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-Copy-4",
    fill: "#000000",
    transform: "translate(17.500000, 15.000000) rotate(90.000000) translate(-17.500000, -15.000000) ",
    points: "16 14 19 14 19 16 16 16"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.5,
    y1: 0.91437502,
    x2: 9.5,
    y2: 11.8868753,
    id: "Path-25",
    stroke: "#000000",
    strokeWidth: 2
  })))))))));
};
export default SvgIcoDownloadBlue;